var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHofPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 75,
    viewBox: "0 0 65 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(-266 -345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    transform: "translate(331 345) rotate(90)",
    fill: "#d1d1d1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 55.09487533569336 63 L 19.90512275695801 63 L 2.308969259262085 32.5 L 19.90512275695801 2 L 55.09487533569336 2 L 72.69103240966797 32.5 L 55.09487533569336 63 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.06026077270508 4 L 4.617958068847656 32.5 L 21.06026077270508 61 L 53.93973541259766 61 L 70.38204956054688 32.5 L 53.93973541259766 4 L 21.06026077270508 4 M 18.75 0 L 56.25 0 L 75 32.5 L 56.25 65 L 18.75 65 L 0 32.5 L 18.75 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M8.472-10.913a14.661,14.661,0,0,1,.83-5.444,11.17,11.17,0,0,1,3.04-3.992,15.547,15.547,0,0,0,2.942-3.2,5.013,5.013,0,0,0,.732-2.6q0-4.126-3.809-4.126a3.863,3.863,0,0,0-2.893,1.111A4.359,4.359,0,0,0,8.179-26.1H1.1a9.4,9.4,0,0,1,3.015-7.3q2.966-2.637,8.093-2.637,5.176,0,8.032,2.5A8.9,8.9,0,0,1,23.1-26.465a8.6,8.6,0,0,1-.928,3.918,16.143,16.143,0,0,1-3.247,4.089l-1.978,1.88A6.7,6.7,0,0,0,14.819-12.4l-.1,1.489Zm-.708,7.5a3.571,3.571,0,0,1,1.111-2.7,3.948,3.948,0,0,1,2.844-1.062,3.948,3.948,0,0,1,2.844,1.062,3.571,3.571,0,0,1,1.111,2.7A3.543,3.543,0,0,1,14.587-.757,3.954,3.954,0,0,1,11.719.293,3.954,3.954,0,0,1,8.85-.757,3.543,3.543,0,0,1,7.764-3.418Z",
    transform: "translate(286 402)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHofPlaceholder);
export default __webpack_public_path__ + "static/media/hof-placeholder.6ecdd3a1.svg";
export { ForwardRef as ReactComponent };